import { isFailure } from '../OperationResult.js';
import { tryExecuteSimple } from '../tryExecuteSimple.js';
const createFetchMessage = (message, details) => ({
    message,
    details,
});
export async function getFetchMessage(widgetUrl) {
    const fetchResult = await tryExecuteSimple(() => fetch(widgetUrl));
    if (isFailure(fetchResult)) {
        return { message: 'Failed to load scripts. Network error.' };
    }
    const response = fetchResult.value;
    if (!response.ok) {
        return { message: `Failed to load scripts. Status: ${response.status} ${response.statusText}.` };
    }
    const readJsResult = await tryExecuteSimple(() => response.text());
    return isFailure(readJsResult)
        ? createFetchMessage('Failed to read body.', readJsResult.fault)
        : createFetchMessage('Failed to import module dynamically.', readJsResult.value);
}
